// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import styled from '@emotion/styled';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
export var KnowledgeCardsPicture = styled.img({
  borderRadius: '50%',
  width: '120px',
  height: '120px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
export var PersonStyles = styled.img({
  borderRadius: '50%',
  width: '32px',
  height: '32px'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
export var WorkStyles = styled.img({
  borderRadius: '0',
  width: '24px',
  height: '24px'
});